export default __webpack_public_path__ + "static/media/deleteIcon.5dd124c0.svg";